<div mat-dialog-title class="dialog-title">
  <div class="dialog-logo" aria-hidden="true">
    @if (tenantLogoUrl(); as logo) {
      <img [src]="logo" alt="" height="24" />
    } @else if (isDarkMode()) {
      <img src="assets/logo-white.svg" alt="" width="120" height="24" />
    } @else {
      <img src="assets/logo.svg" alt="" width="120" height="24" />
    }
  </div>
  <div class="title-text">
    @if (step() === 1) {
      {{ 'qr_language_dialog.mode_title' | transloco }}
    } @else if (readAlongEnabled()) {
      {{ 'qr_language_dialog.title_listen' | transloco }}
    } @else {
      {{ 'qr_language_dialog.title' | transloco }}
    }
  </div>
</div>

<mat-dialog-content class="mat-typography dialog-content">
  @if (step() === 1) {
    <div class="mode-intro">
      {{ 'qr_language_dialog.mode_description' | transloco }}
    </div>

    <div class="mode-grid">
      <button
        mat-button
        type="button"
        class="mode-card listen"
        [disabled]="ttsAudioService.unsupported()"
        [matTooltip]="ttsAudioService.unsupported()
                      ? ('qr_language_dialog.read_along_unsupported' | transloco)
                      : ''"
        (click)="selectMode('listen')">
        <mat-icon class="mode-art" aria-hidden="true">headset</mat-icon>
        <div class="mode-title">{{ 'qr_language_dialog.mode_listen_title' | transloco }}</div>
        <div class="mode-desc">{{ 'qr_language_dialog.mode_listen_desc' | transloco }}</div>
      </button>

      <button
        mat-button
        type="button"
        class="mode-card read"
        (click)="selectMode('read')">
        <mat-icon class="mode-art" aria-hidden="true">chat_bubble_outline</mat-icon>
        <div class="mode-title">{{ 'qr_language_dialog.mode_read_title' | transloco }}</div>
        <div class="mode-desc">{{ 'qr_language_dialog.mode_read_desc' | transloco }}</div>
      </button>
    </div>
  } @else {
    <div class="language-intro">
      {{ 'qr_language_dialog.description' | transloco }}
    </div>

    <div class="language-grid">
      @for (lang of verifiedLanguages(); track lang.languageCode) {
        <button
          #languageButton
          mat-button
          class="language-button"
          [class.selected]="selectedLanguage()?.languageCode === lang.languageCode"
          [attr.data-language-code]="lang.languageCode"
          (click)="selectTranslationLanguage(lang)">
          <div class="language-content">
            <span class="flag-icon" [class]="lang.iconClass"></span>
            <span class="lang-name">{{ lang.exonym.split('(')[0].trim() }}</span>
          </div>
          <mat-icon class="verified-icon">verified</mat-icon>
        </button>
      }

      @for (lang of unverifiedLanguages(); track lang.languageCode) {
        <button
          #languageButton
          mat-button
          class="language-button unverified"
          [class.selected]="selectedLanguage()?.languageCode === lang.languageCode"
          [attr.data-language-code]="lang.languageCode"
          (click)="selectTranslationLanguage(lang)">
          <div class="language-content">
            <span class="flag-icon" [class]="lang.iconClass"></span>
            <span class="lang-name">{{ lang.exonym.split('(')[0].trim() }}</span>
          </div>
        </button>
      }
    </div>
  }
</mat-dialog-content>

<div mat-dialog-actions class="dialog-actions">
  @if (step() === 2) {
    @if (ttsEnabled) {
      <button
        mat-stroked-button
        type="button"
        class="back-button"
        (click)="goBack()">
        {{ 'qr_language_dialog.back' | transloco }}
      </button>
    }
    <button
      mat-raised-button
      color="primary"
      type="button"
      class="confirm-button"
      [disabled]="!selectedLanguage()"
      (click)="confirmLanguageSelection()">
      {{ 'qr_language_dialog.confirm' | transloco }}
    </button>
  }
</div>
